import { generatePath } from 'react-router-dom'
import { SLOTS_IDS_DEFAULT } from '@bcraft-frontend-lib/slots'

import { AltenarSportId, PageTypes as AltPageTypes } from 'shared/models/Altenar'
import { PageTypes as BetByPageTypes, SportIndexes, SportTypes } from 'shared/models/Betby'
import { PageTypes as DgtPageTypes, SportIds, SportViewType } from 'shared/models/Digitain'
import { AvailablePromotionTabs } from 'shared/models/Promotion'
import { UpgamingSportPagesType } from 'shared/models/Upgaming'
import { mediaSize } from '@bcraft-frontend-lib/core'
import { convertView } from 'shared/utils/digitain'

import { SLOTS_ROUTE_URLS } from 'modules/SlotsRoot/redefinitions'

export enum ROUTE_PATHS {
  AUTH = '/auth',
  REFERRAL = '/auth/referral',
  AUTH_SIGN_UP = '/auth/sign-up',
  AUTH_SIGN_UP_WITH_PROMOCODE = '/auth/sign-up/:promocode',
  MAIN = '/main',
  PROFILE = '/profile',
  PROFILE_USERINFO = '/profile/user-info',
  PROFILE_WITHDRAW = '/profile/withdraw',
  PROFILE_TRANSACTIONS = '/profile/transactions',
  PROFILE_PROMOCODE = '/profile/promocode',
  PROFILE_LIMITS = '/profile/limits',
  PROFILE_USERBONUS = '/profile/user-bonus',
  PROFILE_BONUS_PROMOTIONS = '/profile/bonus-promotions',
  PROFILE_SELFEXCLUSION = '/profile/self-exclusion',
  PROFILE_BETHISTORY = '/profile-desktop/betHistory_2',
  PROFILE_BETHISTORY_ALT = '/profile/alt/bet-history',
  PROFILE_BONUSHISTORY = '/profile/bonus-history',
  PROFILE_CASHBACKHISTORY = '/profile/cashback-history',
  PROFILE_BETDETAIL = '/profile/bet-detail',
  PROFILE_REPLENISHMENT = '/profile/replenishment',
  PROFILE_CASHIER_WITHDRAW = '/profile/cashier',
  PROFILE_KYC_VERIFICATION = '/profile/kyc-verifiaction',
  PROFILE_EXCHANGE_BONUS_BALANCE = '/profile/exchange-bonus-balance',
  PROFILE_CHANGE_PASSWORD = '/profile/change-password',
  PROFILE_SPORT_FREE_SPINS = '/profile/sport-free-spins',
  PROFILE_DEPOSIT = '/profile/deposit',
  PROFILE_SLOTS_HISTORY = '/profile/slots-history',
  BALANCE = '/balance',
  HELP = '/help',
  HELP_FAQ = '/faq',
  HELP_IGROVOI_KONT = '/faq/igrovoi-kont',
  HELP_DEPOSITS_WITHDRAWALS = '/faq/depoziti-i-vyplati',
  TERMSANDCONDITIONS = '/terms-and-conditions',
  TERMSANDCONDITIONS_POINT = '/terms-and-conditions/:pointId',
  TERMSANDCONDITIONS_GENERALTERMS = '/terms-and-conditions/generalTerms',
  TERMSANDCONDITIONS_PRIVACYPOLICY = '/terms-and-conditions/privacyPolicy',
  TERMSANDCONDITIONS_RESPONSIBLE_GAMING = '/terms-and-conditions/responsibleGaming',
  IMPORTANT_RULES = '/important-rules',
  PROMOTIONS_DETAIL = '/promotions-detail/:type',
  SOFTION_SPORT = '/sport/sft',
  SOFTION_SPORT_LIVE = '/sport/sft/live',
  FOOTER_GAMING_CURACAO = 'https://licensing.gaming-curacao.com/validator/?lh=686550c5369e6774e220eea348e077e6',
  NEWS = 'https://www.fifa.com/fifaplus/en/tournaments/mens/worldcup/qatar2022',
  PROMOTIONS = '/promotions',

  ALTENAR_SPORT = '/sport/alt/:page?/:sportId?',
  DIGITAIN_SPORT_PAGE = '/sport/dgt/:view/:page?/:id?',
  BETBY_SPORT = '/sport/bby/',

  EMAIL = '/email',
  EMAIL_VERIFY_EMAIL = '/email/verify/email/:token',
  EMAIL_VERIFY_PASSWORD_CONFIRM = '/email/verify/password/confirm/:token',

  WHEEL_GAME = '/wheel-game',

  PROFILE_PROMOTIONS = '/profile/promotions',
  PROFILE_PROMOTIONS_STATUS = '/profile/promotions/:status',

  EMAIL_REDIRECT_DEPOSIT = '/email/redirect/deposit',
  EMAIL_REDIRECT_WHEEL_GAME = '/email/redirect/wheel-game',

  UPGAMING_SPORT_PAGE = '/sport/upgaming/:page',
}

export const ROUTE_URLS = {
  AUTH_SIGN_UP: () => generatePath(ROUTE_PATHS.AUTH_SIGN_UP),
  AUTH_SIGN_UP_WITH_PROMOCODE: (promocode: string) =>
    generatePath(ROUTE_PATHS.AUTH_SIGN_UP_WITH_PROMOCODE, { promocode }),
  MAIN: () => generatePath(ROUTE_PATHS.MAIN),
  PROFILE: () => generatePath(ROUTE_PATHS.PROFILE),
  PROFILE_USERINFO: () => generatePath(ROUTE_PATHS.PROFILE_USERINFO),
  PROFILE_BONUS_PROMOTIONS: () => generatePath(ROUTE_PATHS.PROFILE_BONUS_PROMOTIONS),
  PROFILE_WITHDRAW: () => generatePath(ROUTE_PATHS.PROFILE_WITHDRAW),
  PROFILE_TRANSACTIONS: () => generatePath(ROUTE_PATHS.PROFILE_TRANSACTIONS),
  PROFILE_BONUSHISTORY: () => generatePath(ROUTE_PATHS.PROFILE_BONUSHISTORY),
  PROFILE_CASHBACKHISTORY: () => generatePath(ROUTE_PATHS.PROFILE_CASHBACKHISTORY),
  PROFILE_PROMOCODE: () => generatePath(ROUTE_PATHS.PROFILE_PROMOCODE),
  PROFILE_BETHISTORY: () => generatePath(ROUTE_PATHS.PROFILE_BETHISTORY),
  // PROFILE_BETHISTORY_ALT: () => generatePath(ROUTE_PATHS.PROFILE_BETHISTORY_ALT),
  PROFILE_LIMITS: () => generatePath(ROUTE_PATHS.PROFILE_LIMITS),
  PROFILE_REPLENISHMENT: () => generatePath(ROUTE_PATHS.PROFILE_REPLENISHMENT),
  PROFILE_CASHIER_WITHDRAW: () => generatePath(ROUTE_PATHS.PROFILE_CASHIER_WITHDRAW),
  PROFILE_BETDETAIL: () => generatePath(ROUTE_PATHS.PROFILE_BETDETAIL),
  PROFILE_KYC_VERIFICATION: () => generatePath(ROUTE_PATHS.PROFILE_KYC_VERIFICATION),
  PROFILE_EXCHANGE_BONUS_BALANCE: () => generatePath(ROUTE_PATHS.PROFILE_EXCHANGE_BONUS_BALANCE),
  PROFILE_CHANGE_PASSWORD: () => generatePath(ROUTE_PATHS.PROFILE_CHANGE_PASSWORD),
  PROFILE_SPORT_FREE_SPINS: () => generatePath(ROUTE_PATHS.PROFILE_SPORT_FREE_SPINS),
  PROFILE_DEPOSIT: () => generatePath(ROUTE_PATHS.PROFILE_DEPOSIT),
  PROFILE_SLOTS_HISTORY: () => generatePath(ROUTE_PATHS.PROFILE_SLOTS_HISTORY),
  // PROFILE_SPIN_HISTORY: () => generatePath(ROUTE_PATHS.PROFILE_SPIN_HISTORY),
  PROFILE_PROMOTIONS: () => generatePath(ROUTE_PATHS.PROFILE_PROMOTIONS),
  PROFILE_PROMOTIONS_STATUS: (status: AvailablePromotionTabs) =>
    generatePath(ROUTE_PATHS.PROFILE_PROMOTIONS_STATUS, { status }),
  IMPORTANT_RULES: () => generatePath(ROUTE_PATHS.IMPORTANT_RULES),
  BALANCE: () => generatePath(ROUTE_PATHS.BALANCE),
  HELP: () => generatePath(ROUTE_PATHS.HELP),
  HELP_FAQ: () => generatePath(ROUTE_PATHS.HELP_FAQ),
  HELP_IGROVOI_KONT: () => generatePath(ROUTE_PATHS.HELP_IGROVOI_KONT),
  HELP_DEPOSITS_WITHDRAWALS: () => generatePath(ROUTE_PATHS.HELP_DEPOSITS_WITHDRAWALS),
  TERMSANDCONDITIONS: () => generatePath(ROUTE_PATHS.TERMSANDCONDITIONS),
  TERMSANDCONDITIONS_POINT: (pointId: string) => generatePath(ROUTE_PATHS.TERMSANDCONDITIONS_POINT, { pointId }),
  TERMSANDCONDITIONS_GENERALTERMS: () => generatePath(ROUTE_PATHS.TERMSANDCONDITIONS_GENERALTERMS),
  TERMSANDCONDITIONS_PRIVACYPOLICY: () => generatePath(ROUTE_PATHS.TERMSANDCONDITIONS_PRIVACYPOLICY),
  TERMSANDCONDITIONS_RESPONSIBLE_GAMING: () => generatePath(ROUTE_PATHS.TERMSANDCONDITIONS_RESPONSIBLE_GAMING),
  PROMOTIONS_DETAIL: (type = 'deposit') => generatePath(ROUTE_PATHS.PROMOTIONS_DETAIL, { type }),
  ...SLOTS_ROUTE_URLS,
  SOFTION_SPORT: () => generatePath(ROUTE_PATHS.SOFTION_SPORT),
  SOFTION_SPORT_LIVE: () => generatePath(ROUTE_PATHS.SOFTION_SPORT_LIVE),
  FOOTER_GAMING_CURACAO: () => generatePath(ROUTE_PATHS.FOOTER_GAMING_CURACAO),
  NEWS: () => generatePath(ROUTE_PATHS.NEWS),
  PROMOTIONS: () => generatePath(ROUTE_PATHS.PROMOTIONS),

  ALTENAR_SPORT: (page?: Union<AltPageTypes, string>, sportId?: AltenarSportId) =>
    generatePath(ROUTE_PATHS.ALTENAR_SPORT, { page, sportId }),
  DIGITAIN_SPORT_PAGE: (page: DgtPageTypes, view?: SportViewType, id?: string | SportIds) => {
    const isMobile = window.innerWidth < Number(mediaSize.tablet.replace('px', ''))
    return generatePath(ROUTE_PATHS.DIGITAIN_SPORT_PAGE, {
      view: convertView(isMobile, view),
      page,
      id,
    })
  },
  BETBY_SPORT: (page?: BetByPageTypes) => {
    const convertedPage = page ? `/${SportIndexes[page as SportTypes] || page}` : '/'
    return `${generatePath(ROUTE_PATHS.BETBY_SPORT)}?bt-path=${convertedPage}`
  },
  WHEEL_GAME: () => generatePath(ROUTE_PATHS.WHEEL_GAME),

  UPGAMING_SPORT_PAGE: (page: UpgamingSportPagesType) => generatePath(ROUTE_PATHS.UPGAMING_SPORT_PAGE, { page }),
}

export const SLOTS_GAME_IDS = {
  ...SLOTS_IDS_DEFAULT,
}